import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./CultureLifestyleHealth.css";

const CultureLifestyleHealth = ({
  culturePosts,
  lifestylePosts,
  healthPosts,
  loading,
}) => {
  const [hoveredCard, setHoveredCard] = useState(null);

  const CardSkeleton = () => (
    <div className="culture-card-skeleton">
      <div className="skeleton-image"></div>
      <div className="skeleton-content">
        <div className="skeleton-title"></div>
        <div className="skeleton-meta"></div>
      </div>
    </div>
  );

  const NewsCard = ({ item, category, index, categoryColor = "#e53935" }) => (
    <article
      className={`culture-card ${hoveredCard === item.id ? "hovered" : ""}`}
      onMouseEnter={() => setHoveredCard(item.id)}
      onMouseLeave={() => setHoveredCard(null)}
    >
      <Link to={`/news/${item.id}`} className="culture-card-link">
        <div className="culture-card-image">
          <img src={item.image_url} alt={item.title} />
          <div className="culture-card-overlay">
            <span
              className="culture-category"
              style={{
                backgroundColor: `${categoryColor}20`,
                color: categoryColor,
                boxShadow: `0 4px 12px ${categoryColor}30`,
              }}
            >
              {category}
            </span>
          </div>
        </div>

        <div className="culture-card-content">
          <div>
            <div className="culture-card-meta">
              <span className="culture-card-date">
                <i
                  className="fas fa-calendar-alt"
                  style={{ color: categoryColor }}
                ></i>
                {new Date(item.created_at).toLocaleDateString("sq-AL")}
              </span>
            </div>

            <h4 className="culture-card-title">{item.title}</h4>

            {item.excerpt && (
              <p className="culture-card-excerpt">{item.excerpt}</p>
            )}
          </div>

          <div className="culture-card-footer">
            <span
              className="culture-card-arrow"
              style={{ color: categoryColor }}
            >
              <i className="fas fa-arrow-right"></i>
            </span>
          </div>
        </div>
      </Link>
    </article>
  );

  const SectionHeader = ({ title, linkTo, color = "#e53935" }) => {
    // Determine the section type based on the link
    const getSectionType = (link) => {
      if (link.includes("kulture")) return "culture";
      if (link.includes("lifestyle")) return "lifestyle";
      if (link.includes("shëndetësi")) return "health";
      return "culture";
    };

    const sectionType = getSectionType(linkTo);

    return (
      <div
        className="section-header"
        style={{ borderBottomColor: `${color}20` }}
      >
        <h3 className="section-title">
          {title}
          <span
            style={{
              position: "absolute",
              bottom: "-8px",
              left: "0",
              width: "40px",
              height: "3px",
              background: `linear-gradient(135deg, ${color}, ${color}80)`,
              borderRadius: "2px",
            }}
          ></span>
        </h3>
        <Link to={linkTo} className="see-more-btn" data-section={sectionType}>
          shiko më shumë
          <i className="fas fa-arrow-right"></i>
        </Link>
      </div>
    );
  };

  return (
    <section className="culture-lifestyle-health">
      <div className="container">
        <div className="row">
          {/* Culture Section */}
          <div className="col-12 mb-5">
            <div className="section-box">
              <SectionHeader
                title="Kulturë"
                linkTo="/kulture"
                color="#e53935"
              />
              <div className="section-content">
                {loading ? (
                  Array.from({ length: 3 }).map((_, index) => (
                    <CardSkeleton key={`culture-skeleton-${index}`} />
                  ))
                ) : !culturePosts || culturePosts.length === 0 ? (
                  <div className="no-posts-message culture-no-posts">
                    <i className="fas fa-newspaper"></i>
                    <h3>Nuk ka lajme të disponueshme</h3>
                    <p>Ju lutem kontrolloni më vonë për lajme të reja.</p>
                  </div>
                ) : (
                  culturePosts
                    .slice(0, 3)
                    .map((item, index) => (
                      <NewsCard
                        key={item.id}
                        item={item}
                        category="Kulturë"
                        index={index}
                        categoryColor="#e53935"
                      />
                    ))
                )}
              </div>
            </div>
          </div>

          {/* Lifestyle Section */}
          <div className="col-12 mb-5">
            <div className="section-box">
              <SectionHeader
                title="Lifestyle"
                linkTo="/lifestyle"
                color="#e53935"
              />
              <div className="section-content">
                {loading ? (
                  Array.from({ length: 3 }).map((_, index) => (
                    <CardSkeleton key={`lifestyle-skeleton-${index}`} />
                  ))
                ) : !lifestylePosts || lifestylePosts.length === 0 ? (
                  <div className="no-posts-message lifestyle-no-posts">
                    <i className="fas fa-heart"></i>
                    <h3>Nuk ka lajme të disponueshme</h3>
                    <p>Ju lutem kontrolloni më vonë për lajme të reja.</p>
                  </div>
                ) : (
                  lifestylePosts
                    .slice(0, 3)
                    .map((item, index) => (
                      <NewsCard
                        key={item.id}
                        item={item}
                        category="Lifestyle"
                        index={index}
                        categoryColor="#e53935"
                      />
                    ))
                )}
              </div>
            </div>
          </div>

          {/* Health Section */}
          {healthPosts?.length > 0 && (
            <div className="col-12 mb-5">
              <div className="section-box">
                <SectionHeader
                  title="Shëndetësi"
                  linkTo="/category/shëndetësi"
                  color="#e53935"
                />
                <div className="section-content">
                  {loading ? (
                    Array.from({ length: 3 }).map((_, index) => (
                      <CardSkeleton key={`health-skeleton-${index}`} />
                    ))
                  ) : !healthPosts || healthPosts.length === 0 ? (
                    <div className="no-posts-message health-no-posts">
                      <i className="fas fa-heartbeat"></i>
                      <h3>Nuk ka lajme të disponueshme</h3>
                      <p>Ju lutem kontrolloni më vonë për lajme të reja.</p>
                    </div>
                  ) : (
                    healthPosts
                      .slice(0, 3)
                      .map((item, index) => (
                        <NewsCard
                          key={item.id}
                          item={item}
                          category="Shëndetësi"
                          index={index}
                          categoryColor="#e53935"
                        />
                      ))
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default CultureLifestyleHealth;
